import notificationService from '@utils/notificationService';
import apiPayment from '@api/apiPayment';

export const START_REQUEST = 'START_REQUEST';
export const STOP_REQUEST = 'STOP_REQUEST';
export const FETCH_INVOICES_START = 'FETCH_INVOICES_START';
export const FETCH_INVOICES_SUCCESS = 'FETCH_INVOICES_SUCCESS';
export const FETCH_INVOICES_FAILURE = 'FETCH_INVOICES_FAILURE';

export const startRequest = () => ({ type: START_REQUEST });
export const stopRequest = () => ({ type: STOP_REQUEST });

export const fetchInvoices = (lastId = '') => async (dispatch) => {
  dispatch({ type: FETCH_INVOICES_START });
  try {
    const { data } = await apiPayment.fetchInvoices(lastId);
    dispatch({ type: FETCH_INVOICES_SUCCESS, invoices: data.items, hasMoreInvoices: data.has_more });
    return true;
  } catch (error) {
    dispatch({ type: FETCH_INVOICES_FAILURE });
    notificationService.error({ message: error.message });
    return false;
  } finally {
    dispatch(stopRequest());
  }
};
